import _ from 'lodash'

export const Mutations = {
  setToken(state, ui) {
    state.token = ui;
  },
  setSnapshotDateFilter(state, ui) {
    state.snapshotDateFilter = ui;
  },
  setSearchFilterObj (state, ui) {
    state.searchFilterObj = ui;
  },
  setSortBy (state, ui) {
    state.sortBy = ui
  },
  setSortDesc (state, ui) {
    state.sortDesc = ui
  },
  setEstimatesPerPage (state, ui) {
    state.estimatesPerPage = ui
  },
  setEstimatesAllCurrentPage (state, ui) {
    state.estimatesAllCurrentPage = ui
  },
  loadEstimates (state, ui) {
    const itemMap = new Map();
    for (let i = 0; i < state.items.length; i++) {
      const existing = state.items[i]
      const existingId = Number(existing.estimateId || existing.estimate_id)
      if (!Number.isNaN(existingId)) {
        existing.estimateId = existingId
        existing.estimate_id = Number(existing.estimate_id || existingId)
        itemMap.set(existingId, existing)
      }
    }

    for (let i = 0; i < ui.length; i++) {
      const estimate = ui[i]
      const estimateId = Number(estimate.estimateId || estimate.estimate_id)
      if (Number.isNaN(estimateId)) {
        continue
      }
      estimate.estimateId = estimateId
      estimate.estimate_id = Number(estimate.estimate_id || estimateId)
      itemMap.set(estimateId, estimate)
    }

    const items = Array.from(itemMap.values())
    items.sort((a, b) => Number(b.estimate_id || b.estimateId) - Number(a.estimate_id || a.estimateId))
    state.items = items

    console.log('LOADED.loadEstimates')
    return;
    // let data = _.union(ui, state.items)
    // let res = _.uniqWith(data, function (first, second) {
    //   return (first.estimateId != second.estimateId) ? false : true
    // })

    // res = _.map(res, (i) => {
    //   i.estimate_id = Number(i.estimate_id)
    //   return i
    // })

    // state.items = res
    // console.log('LOADED.loadEstimates')
  },
  setTimestamp (state, timestamp = 0) {
    console.log('timestamp', timestamp)
    state.timestamp = timestamp
  },
  logout (state) {
    state.timestamp = 0
    state.items = []
  },
  estimatesUpdated (state, ui) {
    // let newEstimates = _.map(ui, (i) => {
    //   i.estimate_id = Number(i.estimate_id)
    //   return i
    // })
    const itemMap = new Map();
    for (let i = 0; i < state.items.length; i++) {
      const existing = state.items[i]
      const existingId = Number(existing.estimateId || existing.estimate_id)
      if (!Number.isNaN(existingId)) {
        existing.estimateId = existingId
        existing.estimate_id = Number(existing.estimate_id || existingId)
        itemMap.set(existingId, existing)
      }
    }

    for (let i = 0; i < ui.length; i++) {
      const estimate = ui[i]
      const estimateId = Number(estimate.estimateId || estimate.estimate_id)
      if (Number.isNaN(estimateId)) {
        continue
      }
      estimate.estimateId = estimateId
      estimate.estimate_id = Number(estimate.estimate_id || estimateId)
      itemMap.set(estimateId, estimate)
    }

    const items = Array.from(itemMap.values())
    items.sort((a, b) => Number(b.estimate_id || b.estimateId) - Number(a.estimate_id || a.estimateId))
    state.items = items
  },
  deleteEstimateById (state, id) {
    let estimate = _.filter(state.items, function (estimate) {
      return parseInt(estimate.estimateId) === parseInt(id)
    })

    for (let i = 0; i < estimate.length; i++) {
      let index = state.items.indexOf(estimate[i])
      state.items.splice(index, 1)
    }
  },
  deleteEstimateByCardId (state, id) {
    let estimate = _.filter(state.items, function (estimate) {
      return parseInt(estimate.card_id) === parseInt(id)
    })

    for (let i = 0; i < estimate.length; i++) {
      let index = state.items.indexOf(estimate[i])
      state.items.splice(index, 1)
    }
  }
}
